export default __webpack_public_path__ + "static/media/inner5.d4519970.jpg";